import { axiosInstance } from "@/axios/interceptors";

export default {
  getResourceBoards: async (data: any) => {
    return await axiosInstance.get(`resourceboards`, { params: data });
  },
  getResourceBoard: async (seq: number) => {
    return await axiosInstance.get(`resourceboards/${seq}`);
  },

  downloadResourceBoardFile(seq: number, index: number, filename: string) {
    return axiosInstance
      .get(`resourceboards/${seq}/download-attach-files/${index}`, {
        responseType: "blob",
      })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); // You can set the file name here
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  },
};
